
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useToast } from "@/components/ui/use-toast";
import { motion } from "framer-motion";

const Newsletter = () => {
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { toast } = useToast();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    setTimeout(() => {
      toast({
        title: "Thank you for subscribing!",
        description: "You'll receive our updates at " + email,
      });
      setEmail("");
      setIsSubmitting(false);
    }, 1000);
  };

  return (
    <section className="bg-bunnie-peach/20 py-16">
      <div className="container-custom">
        <div className="max-w-2xl mx-auto text-center">
          <h2 className="font-serif text-3xl md:text-4xl text-bunnie-brown mb-4">
            Join Our Community
          </h2>
          <p className="text-bunnie-brown/70 mb-8">
            Subscribe to receive updates, exclusive offers, and beauty tips directly to your inbox.
          </p>
          <motion.form 
            onSubmit={handleSubmit} 
            className="flex flex-col md:flex-row gap-4 max-w-lg mx-auto justify-center"
            whileInView={{ opacity: 1, y: 0 }}
            initial={{ opacity: 0, y: 20 }}
            viewport={{ once: true }}
            transition={{ duration: 0.5, delay: 0.2 }}
          >
            <Input
              type="email"
              placeholder="Your email address"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              className="flex-grow bg-white border-bunnie-brown/20 focus:border-bunnie-brown"
            />
            <Button 
              type="submit" 
              className="bg-bunnie-brown text-white hover:bg-opacity-90 md:w-auto w-full"
              disabled={isSubmitting}
            >
              {isSubmitting ? "Subscribing..." : "Subscribe"}
            </Button>
          </motion.form>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;
